export default __webpack_public_path__ + "static/media/Plissee 45.572d1959.jpg";